import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorVariant } from '@percent/domain/verifications'
import { Checkbox, Flex, Loader, Typography } from '@percent/lemonade'
import { useProgress } from '@percent/product-nomination-form/hooks'
import { Card, Stepper } from '@percent/product-nomination-form/ui'
import { ErrorCard } from '@percent/product-nomination-form/ui/ErrorCard/ErrorCard'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'

import styles from './Terms.module.scss'
import { TermsProps } from './Terms.types'

export const Terms = ({ handleFormSubmit, isLoading, isError }: TermsProps) => {
  const { handleBack } = useValidationStepData()
  const [isChecked, setIsChecked] = useState(false)
  const { t } = useTranslation()
  const { progress } = useProgress()

  const label = (
    <Typography className={styles.label} variant="default-medium">
      {t('hostedValidation.terms.agreeTerms')}
    </Typography>
  )

  if (isLoading) {
    return (
      <Card>
        <Loader />
      </Card>
    )
  }

  if (isError) {
    return (
      <ErrorCard
        title={t('hostedValidation.errorMessage.somethingWentWrong')}
        subtitle={t('hostedValidation.errorMessage.reloadPage')}
        variant={ErrorVariant.INTERNAL}
      />
    )
  }

  return (
    <Card
      onBack={handleBack}
      title={t('hostedValidation.title.almostFinished')}
      description={t('hostedValidation.title.firstConfirm')}
      onNext={handleFormSubmit}
      nextButtonLabel={t('hostedValidation.button.next')}
      nextButtonDisabled={!isChecked}
      progress={progress}
    >
      <Flex direction="column" gap={40} w="368px" mt={48}>
        <Stepper />
        <Checkbox
          variant="default"
          active={isChecked}
          name="agreement"
          label={label}
          onChange={(event) => {
            const isChecked = (event as React.ChangeEvent<HTMLInputElement>)
              .target.checked
            setIsChecked(isChecked)
          }}
          disabled={false}
        />
      </Flex>
    </Card>
  )
}
